export const shortenShopifyId = (shopifyId: string) => {
  return (shopifyId ?? '').split('/').pop() ?? shopifyId
}
